module.exports = __webpack_public_path__ + "img/GSK_bg_md.dafe4008.png";